import React from 'react';

import { CloudinaryVideo } from '../../cloudinary-resources/CloudinaryVideo';
import { Video } from '../domain/Video';

interface GalleryVideoProps {
  video: Video;
  tenant: string;
  canonicalDomain: string;
  playerId: string;
}

export const GalleryVideo: React.FC<GalleryVideoProps> = (props) => {
  return (
    <CloudinaryVideo
      publicId={props.video.id}
      playerId={props.playerId}
      tenant={props.tenant}
      canonicalDomain={props.canonicalDomain}
      videoConfig={{
        playsInline: true,
        preload: 'none',
        transformation: {
          aspectRatio: '1:1',
          crop: 'fill',
          width: '700',
          height: '700',
          gravity: 'auto',
          transformation: {
            dpr: 'auto',
            quality: 'auto',
            format: 'auto',
          },
        },
        autoplay: props.video.autoplay,
        loop: props.video.loop,
        muted: props.video.autoplay,
      }}
      posterUrl={props.video.posterImage}
      altText={props.video.videoAlt}
    />
  );
};
